module.exports = __webpack_public_path__ + "img/button-more.1e175aa7.png";